module.exports = __webpack_public_path__ + "img/pt.83eae4c6.svg";